module.exports = {
  roleName: '角色名称',
  roleDescription: '角色描述',
  category: '类别',
  permissionName: '权限名称',
  permissionDescription: '权限描述',
  selectAll: '全选',
  error702: '角色名称重复'
}
